var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 61,
  height: 61,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M30.5 59.5c16.016 0 29-12.984 29-29s-12.984-29-29-29-29 12.984-29 29 12.984 29 29 29Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.164 39.335a1.078 1.078 0 0 1-1.664-.906V22.982c0-.854.947-1.37 1.664-.905L39.101 29.8a1.078 1.078 0 0 1 0 1.811z"
})));
export { SvgVideoPlay as ReactComponent };
export default "/_next/static/images/videoPlay.svg";